@if (item()) {
  <div class="treeview-item">
    <ng-template [ngTemplateOutlet]="template()"
      [ngTemplateOutletContext]="{item: item()!, onCollapseExpand: onCollapseExpand, onCheckedChange: onCheckedChange, parent: parent()}">
    </ng-template>
    @if (!item()!.collapsed) {
      <div>
        @for (child of item()!.children; track child) {
          <app-treeview-item [config]="config()" [item]="child" [template]="template()" [parent]="item()"
            (checkedChange)="onChildCheckedChange(child, $event)">
          </app-treeview-item>
        }
      </div>
    }
  </div>
}
